import React, { Component } from 'react';
import { Nav, NavItem } from 'reactstrap';
import { Link } from "react-router-dom";
import './aside.scss';

class Aside extends Component {
    render() {
        const location = this.props.history.location;
        return (
            <aside className="app-aside">
                <Nav vertical>
                    <NavItem>
                        <Link className={location.pathname === "/my-tasks" ? "nav-link active" : "nav-link"} onClick={this.props.showHideMenu} to="/my-tasks">My Cases</Link>
                    </NavItem>
                    <NavItem>
                        {/* <Link className={location.pathname === "/billing" ? "nav-link active" : "nav-link"} onClick={this.props.showHideMenu} to="/billing">Billing</Link> */}
                    </NavItem>
                    <NavItem>
                        {/* <Link className={location.pathname === "/contact-rubix" ? "nav-link active" : "nav-link"} onClick={this.props.showHideMenu} to="/contact-rubix">Contact Rubix</Link> */}
                        <a href="mailto:admin@rubixds.com?cc=pravin.naik@rubixds.com&bcc=ankita.drolia@rubixds.com&Subject=Query / Issue" className={location.pathname === "/contact-rubix" ? "nav-link active" : "nav-link"} >Contact Rubix</a>
                    </NavItem>
                </Nav>
            </aside>
        );
    }
}

export default Aside;
